export default "__VITE_ASSET__BKCIpMTM__"